export const ChevronLeft = ({
  size = 24,
  color = '#4FC0CF',
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6485 18.8486C16.1172 18.3799 16.1172 17.6202 15.6485 17.1515L10.4971 12.0001L15.6485 6.84858C16.1172 6.37995 16.1172 5.62015 15.6485 5.15152C15.1799 4.68289 14.4201 4.68289 13.9515 5.15152L7.95147 11.1515C7.48284 11.6202 7.48284 12.3799 7.95147 12.8486L13.9515 18.8486C14.4201 19.3172 15.1799 19.3172 15.6485 18.8486Z"
        fill={color}
      />
    </svg>
  );
};
